const ColorStyles = `
  :root {
    --nts-black: rgb(0, 0, 0);
    --nts-white: rgb(255, 255, 255);
    --nts-red: rgb(244, 23, 23);
    --nts-grey-dark: rgb(102, 102, 102);
    --nts-grey-mid-dark: rgb(102, 102, 102);
    --nts-mid-grey: rgba(255, 255, 255, 0.3);
    --nts-grey-mid-light: rgb(153, 153, 153);
    --nts-grey-light: rgb(204, 204, 204);
  }
`

export default ColorStyles
